import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LetDirective } from '@ngrx/component';
import { AuthStore } from '@store';
import { AssistantOverlayTypeEnum, AssistantStore } from '../../../@store/assistant';
import { CommonStandaloneModule } from '../../../shared/common-standalone.module';
import { AssistantService } from '../../assistant.service';
import { AssistantFeedbackExportListComponent } from '../overlays/assistant-feedback/assistant-feedback-export-list/assistant-feedback-export-list.component';
import { Location } from '@angular/common';

@Component({
  selector: 'app-assistant-overlay-action-buttons',
  templateUrl: './assistant-overlay-action-buttons.component.html',
  styleUrls: ['./assistant-overlay-action-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonStandaloneModule,
    MatButtonModule,
    MatIconModule,
    LetDirective,
    AssistantFeedbackExportListComponent,
  ],
})
export class AssistantOverlayActionButtonsComponent {
  @Input() overlay: AssistantOverlayTypeEnum;

  constructor(
    public assistantStore: AssistantStore,
    public authStore: AuthStore,
    public assistantService: AssistantService,
    private location: Location
  ) {}

  protected readonly Overlay = AssistantOverlayTypeEnum;

  closeDocument(overlayPrevious: AssistantOverlayTypeEnum): void {
    this.assistantService.closeOverlay(overlayPrevious);
    this.location.replaceState('/assistant');
  }
}
